module.exports = __webpack_public_path__ + "img/85.4741c831.png";